export default __webpack_public_path__ + "static/media/Programação (Real Size).f10e7b93.svg";